import { useState } from 'react';
import { __ } from '@wordpress/i18n';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';

// store
import { storeSet } from '../../store';

// components
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

/**
 * @param {function} [renderTrigger] receives the open handler, so callers with
 *                                   their own button styling can supply it.
 */
const ModalEditBrief = ({ projectId, brief, renderTrigger }) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [value, setValue] = useState(brief || '');
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setValue(brief || '');
        setModalVisible(true);
    };

    const handleClose = () => {
        setValue(brief || '');
        setModalVisible(false);
    };

    const handleSave = async () => {
        const formData = new FormData();
        formData.append('Payload', JSON.stringify({ id: projectId, brief: value }));

        setLoading(true);
        try {
            await storeSet('createUpdateProject', formData);
            handleSuccessAndDisplay(__('Brief aggiornato con successo!', 'soundbetween'));
            setModalVisible(false);
        } catch (error) {
            // Error already displayed by store action
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {renderTrigger
                ? renderTrigger(handleOpen)
                : <ButtonFlat onClick={handleOpen}>
                    {__('Modifica', 'soundbetween')}
                </ButtonFlat>}
            {modalVisible
                ? <ModalDialog
                    additionalClasses={['modalEditBrief']}
                    header={__('Modifica il brief', 'soundbetween')}
                    visible={modalVisible}
                    width={860}
                    onHide={handleClose}>
                    <div className="modalEditBrief__editorWrapper" data-color-mode="dark">
                        <MDEditor
                            value={value}
                            onChange={setValue}
                            height={440}
                            preview="edit"
                        />
                    </div>
                    <div className="appFormActions">
                        <ButtonFlat size="lg" type="button" onClick={handleClose}>
                            {__('Annulla', 'soundbetween')}
                        </ButtonFlat>
                        <ButtonFormSubmit disabled={loading} onClick={handleSave}>
                            {__('Salva', 'soundbetween')}
                        </ButtonFormSubmit>
                    </div>
                </ModalDialog> : null}
        </>
    );
};

export default ModalEditBrief;
